import type { AvailabilityOptions } from '../redux/appConfigReducer';

export const parseAvailabilityOptions: (
  nowLabel: string | undefined | null,
  allLabel: string | undefined | null,
) => AvailabilityOptions = (nowLabel, allLabel) => {
  return {
    now: {
      label: nowLabel || '',
    },
    all: {
      label: allLabel || '',
    },
  };
};
